import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchCompanyRequest, createCompanyRequest, editCompanyRequest } from "../../../api/company";

class CompanyForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        companyName: ''
      },
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchCompanyRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      companyName
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      companyName
    };

    if (isNewRecord) {
        createCompanyRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editCompanyRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('company');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Company.' })
  }

  render() {

    const {
      companyName
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const {
      error
    } = this.state;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('company')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Company Name</ControlLabel>
                  <FormControl
                    type="text"
                    name="companyName"
                    value={companyName}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                {error &&
                  <Alert bsStyle="danger">
                    {error}
                  </Alert>
                }
                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default CompanyForm;
